<div class="cart-view">

  <div class="cart-info">
    <h1>Книги из библиотеки</h1>

    <div *ngFor="let item of bookingItems" class="products">
      <booking-item [bookingItem]="item"></booking-item>
    </div>

  </div>

  <div class="cart-buttons" *ngIf="bookingItems.length > 0">

      <h3>Введите email</h3>
      <input class="base-input  email" [(ngModel)]="email"/>
      <button mat-button class="main-button order-button" (click)="book()">Забронировать</button>
      <div class="error-card" *ngIf="noValidEmail">Email не верный</div>
    <div *ngIf="noValidSubscription">
      <div class="error-card">Подписка не найдена</div>
      <div class="library-subscription-link" (click)="navigate('library-subscription')" >Управление подпиской</div>



    </div>

  </div>
</div>
